import { Col, Row } from "antd";
import { useEffect, useState, useRef } from "react";
import GetIframe from "./GetIframe";
import PostIframe from "./PostIframe";

const PanelsRow = ({
  title,
  url,
  timeSeriesPanel,
  histogramPanel,
  boxPlotPanel,
  baseFilterObject,
  staticFilterObject,
  variableKeys,
  isPostIframe,
  postFilterList,
  data,
}) => {
  const summaryCount = data ? data : 0;
  const [view, setView] = useState(false);
  const cardRowRef = useRef(null);

  useEffect(() => {
    const currentRef = cardRowRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
    // eslint-disable-next-line 
  }, []);

  const getTimeseriesId = () => {
    return isPostIframe
      ? "timeseries-post-" +
          summaryCount +
          "-" +
          title.toLowerCase().replace(/\s/g, "-")
      : "timeseries-" +
          summaryCount +
          "-" +
          title.toLowerCase().replace(/\s/g, "-");
  };

  const getHistogramId = () => {
    return isPostIframe
      ? "histogram-post-" +
          summaryCount +
          "-" +
          title.toLowerCase().replace(/\s/g, "-")
      : "histogram-" +
          summaryCount +
          "-" +
          title.toLowerCase().replace(/\s/g, "-");
  };
  const getBoxPlotId = () => {
    return isPostIframe
      ? "boxPlot-post-" +
          summaryCount +
          "-" +
          title.toLowerCase().replace(/\s/g, "-")
      : "boxPlot-" +
          summaryCount +
          "-" +
          title.toLowerCase().replace(/\s/g, "-");
  };
  return (
    <Row gutter={[12, 12]} className="pdtb05">
      {timeSeriesPanel &&
        (isPostIframe ? (
          <Col xs={24} sm={24} md={24} flex={"auto"} id={getTimeseriesId()}>
            <PostIframe
              title={"Time Series - " + title}
              url={url}
              panelId={timeSeriesPanel}
              variableObject={baseFilterObject}
              staticVariableObject={staticFilterObject}
              variableKeys={variableKeys}
              width="100%"
              height="240"
              postFilterList={postFilterList}
              divId={getTimeseriesId()}
            />
          </Col>
        ) : (
          <Col ref={cardRowRef} xs={24} sm={24} md={24} flex={"auto"} id={getTimeseriesId()}>
            {view ?
              <GetIframe
                title={"Time Series - " + title}
                url={url}
                panelId={timeSeriesPanel}
                variableObject={baseFilterObject}
                staticVariableObject={staticFilterObject}
                variableKeys={variableKeys}
                width="100%"
                height="240"
                divId={getTimeseriesId()}
              />
            : null }
          </Col>
        ))}

      {histogramPanel &&
        (isPostIframe ? (
          <Col xs={24} sm={24} md={24} flex={"auto"} id={getHistogramId()}>
            <PostIframe
              title={"Histogram - " + title}
              url={url}
              panelId={histogramPanel}
              variableObject={baseFilterObject}
              staticVariableObject={staticFilterObject}
              variableKeys={variableKeys}
              width="100%"
              height="240"
              postFilterList={postFilterList}
              divId={getHistogramId()}
            />
          </Col>
        ) : (
          <Col ref={cardRowRef} xs={24} sm={24} md={24} flex={"auto"} id={getHistogramId()}>
            {view ?
              <GetIframe
                title={"Histogram - " + title}
                url={url}
                panelId={histogramPanel}
                variableObject={baseFilterObject}
                staticVariableObject={staticFilterObject}
                variableKeys={variableKeys}
                width="100%"
                height="240"
                divId={getHistogramId()}
              />
            : null }
          </Col>
        ))}

      {boxPlotPanel &&
        (isPostIframe ? (
          <Col xs={24} sm={24} md={24} flex={"auto"} id={getBoxPlotId()}>
            <PostIframe
              title={"Box Plot - " + title}
              url={url}
              panelId={boxPlotPanel}
              variableObject={baseFilterObject}
              staticVariableObject={staticFilterObject}
              variableKeys={variableKeys}
              width="100%"
              height="240"
              postFilterList={postFilterList}
              divId={getBoxPlotId()}
            />
          </Col>
        ) : (
            <Col ref={cardRowRef} xs={24} sm={24} md={24} flex={"auto"} id={getBoxPlotId()}>
            {view ?
              <GetIframe
                title={"Box Plot - " + title}
                url={url}
                panelId={boxPlotPanel}
                variableObject={baseFilterObject}
                staticVariableObject={staticFilterObject}
                variableKeys={variableKeys}
                width="100%"
                height="240"
                divId={getBoxPlotId()}
              />
            : null }
            </Col>
        ))}
    </Row>
  );
};

export default PanelsRow;
